import React, { useContext, createContext, FC, ReactNode } from "react";
import { useState, useEffect } from "react";
import { fetchData } from "../Services/GlobalService";

interface DistributorContextProps {
    confirmPassPopup: boolean;
    setConfirmPassPopup: (value: boolean) => void;
    constUserId: string;
    setconstUserId: (value: any) => void;
    userDetails: any[];
    setUserDetails: (value: any[]) => void;
    StateAPICall: () => void;
    DistrictAPICall: () => void;
    TownAPICall: () => void;
    stateSuggetion: any[];
    districtSuggetion: any[];
    townSuggetion: any[];
    selectedState: { GEOG_ID?: string, NAME?: string };
    setSelectedState: (value: { GEOG_ID?: string, NAME?: string }) => void;
    selectedDist :{ GEOG_ID?: string, NAME?: string };
    setSelectedDist :(value: { GEOG_ID?: string, NAME?: string }) => void;
    selectedTown : { GEOG_ID?: string, NAME?: string };
    setSelectedTown :(value: { GEOG_ID?: string, NAME?: string }) => void;
}

const DistributorContext = createContext<DistributorContextProps>(
    {} as DistributorContextProps
);

interface DistributorProviderProps {
    children: ReactNode;
}

const DistributorProvider: FC<DistributorProviderProps> = ({
    children,
}) => {
    const ControllerDistributor = "masters/Distributer/DistributerDetails"
    const EndPoint = {
        GetGeography: "GetGeography"
    };
    const UserId = localStorage.getItem("UserId")?.toString();
    const [confirmPassPopup, setConfirmPassPopup] = useState<boolean>(false);
    const [constUserId, setconstUserId] = useState("");
    const [userDetails, setUserDetails] = useState<any[]>([]);
    const [stateSuggetion, setStateSuggetion] = useState<any[]>([]);
    const [districtSuggetion, setDistrictSuggetion] = useState<any[]>([]);
    const [townSuggetion, setTownSuggetion] = useState<any[]>([]);
    const [selectedState, setSelectedState] = useState<{ GEOG_ID?: string, NAME?: string }>({});
    const [selectedDist, setSelectedDist] = useState<{ GEOG_ID?: string, NAME?: string }>({});
    const [selectedTown, setSelectedTown] = useState<{ GEOG_ID?: string, NAME?: string }>({});

    const StateAPICall = async () => {
        let GetState = await fetchData(ControllerDistributor,
            `${EndPoint.GetGeography}`,
            `UserId=${UserId}&intGeogLevel=1`
        );
        setStateSuggetion(GetState.Data)
    }

    const DistrictAPICall = async () => {
        let GetState = await fetchData(ControllerDistributor,
            `${EndPoint.GetGeography}`,
            `UserId=${UserId}&intGeogLevel=2&strGeogParentId=${selectedState.GEOG_ID}`
        );
        setDistrictSuggetion(GetState.Data)
    }

    const TownAPICall = async () => {
        let GetState = await fetchData(ControllerDistributor,
            `${EndPoint.GetGeography}`,
            `UserId=${UserId}&intGeogLevel=3&strGeogParentId=${selectedDist.GEOG_ID}`
        );
        setTownSuggetion(GetState.Data)
    }
    return (
        <DistributorContext.Provider
            value={{
                confirmPassPopup,
                setConfirmPassPopup,
                constUserId,
                setconstUserId,
                userDetails,
                setUserDetails,
                StateAPICall,
                stateSuggetion,
                setSelectedState,
                selectedState,
                districtSuggetion,
                townSuggetion,
                DistrictAPICall,
                TownAPICall,
                selectedDist,
                setSelectedDist,
                selectedTown,
                setSelectedTown
            }}
        >
            {children}
        </DistributorContext.Provider>
    );
};

export const useDistributorContext = () => {
    return useContext(DistributorContext);
};

export { DistributorProvider, DistributorContext };